/** Erro de validação/aplicação. Nunca deixa a sequência num estado parcial. */
export class CommandError extends Error {
    code;
    constructor(code, message) {
        super(message);
        this.name = 'CommandError';
        this.code = code;
    }
}
let counter = 0;
/**
 * Fábrica de comandos. Ids e timestamps entram no objeto (nunca são gerados dentro do
 * reducer) para que reaplicar o mesmo log produza exatamente o mesmo resultado.
 */
export function cmd(input) {
    counter = (counter + 1) % 1_000_000;
    return {
        id: input.id ?? `cmd_${Date.now().toString(36)}${counter.toString(36).padStart(4, '0')}`,
        type: input.type,
        sequenceId: input.sequenceId,
        payload: input.payload,
        source: input.source ?? 'USER',
        actorId: input.actorId,
        changeId: input.changeId,
        reason: input.reason,
        createdAt: input.createdAt ?? new Date().toISOString(),
    };
}
//# sourceMappingURL=types.js.map